export default __webpack_public_path__ + "static/media/prismaLogo.b44ca3e0.png";